<template>
  <div class="dashboard-container">
	  <div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">
			用户管理>用户运营>{{activeName=="first"?"用户分群":""}}{{activeName=="two"?"运营计划":""}}{{activeName=="three"?"标签管理":""}}
	</div>
      <el-tabs v-model="activeName" class="tas" type="card" @tab-click="handleClick">
          <el-tab-pane label="用户分群" name="first">
			   <Hair></Hair>
		  </el-tab-pane>
          <el-tab-pane label="运营计划" name="two">
			  <Hair2></Hair2>
          </el-tab-pane>
		  <el-tab-pane label="标签管理" name="three">
			  <num3></num3>
		  </el-tab-pane>
      </el-tabs>
  </div>
</template>
<script>
import Hair from "./operaplan/operaplan1.vue"
import Hair2 from "./operaplan/operaplan2.vue"
import num3 from "./operaplan/operaplan3.vue"
export default {
	components:{
	 Hair,Hair2,num3
	},
  data() {
    return {
      activeName: 'three',
    }
  },
  mounted(){},
  methods: {
    handleClick(tab, event) {
		// console.log(this.activeName)
    }
  }
}
</script>
